import { useMutation, useQueryClient } from '@tanstack/react-query';
import attachCredits from '../../api/credits/attach-credits';
import refetchCart from '../cart/refetch-cart';

const useAttachCredits = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: attachCredits,
        onSuccess: () => refetchCart(queryClient)
    });
};

export default useAttachCredits;
